var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"side",attrs:{"mode":"vertical","default-active":_vm.defaultActive}},[_vm._l((_vm.sideMenu),function(menu){return [_c('el-menu-item',{key:menu.name,attrs:{"index":menu.index},on:{"click":function($event){return _vm.handleMenuClick(menu)}}},[_c('span',{staticClass:"top-tab-content"},[_vm._v(_vm._s(menu.label))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }